export const traverseFind = <T>(tree: T, getChildren: (t: T) => T[], test: (t: T) => boolean): T | null => {
  if (test(tree)) {
    return tree;
  }

  const children = getChildren(tree) || [];

  return children.reduce((found, node) => {
    return found ? found : traverseFind(node, getChildren, test);
  }, null);
};

export const traverseValuesToArray = <T, U>(
  tree: T,
  getChildren: (t: T) => T[],
  getValue: (t: T) => U,
  acc: U[] = []
): U[] => {
  acc.push(getValue(tree));
  const children = getChildren(tree);
  if (children) {
    children.forEach((c) => traverseValuesToArray(c, getChildren, getValue, acc));
  }
  return acc;
};
